import { Tooltip, type TooltipProps } from '@mui/material'

type CustomTooltipProps = {
  children: React.ReactNode
  variant?: 'dark' | 'light'
  style?: React.CSSProperties
} & TooltipProps

const variantColors = {
  dark: {
    bg: '#101828',
    color: '#fff',
    borderColor: '#101828',
  },
  light: {
    bg: '#fff',
    color: '#101828',
    borderColor: '#eaeef2',
  },
}

export function CustomTooltip({ children, style, ...rest }: CustomTooltipProps) {
  const { variant = 'light', placement = 'top' } = rest

  const palette = variantColors[variant]

  return (
    <Tooltip
      arrow
      componentsProps={{
        arrow: { sx: { color: palette.bg } },
        tooltip: {
          sx: {
            bgcolor: palette.bg,
            p: '12px',
            border: `1px solid ${palette.borderColor}`,
            color: palette.color,
            borderRadius: '8px',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
          },
        },
      }}
      placement={placement}
      style={style}
      {...rest}
    >
      <div>{children}</div>
    </Tooltip>
  )
}
